import { useState, useEffect } from 'react';
import LicenseService from '../services/LicenseService';

const useCPFValidation = (initialCPF = '') => {
  const [cpf, setCPF] = useState(initialCPF);
  const [isValidating, setIsValidating] = useState(false);
  const [validationResult, setValidationResult] = useState(null); // { success, message, valid, available }

  useEffect(() => {
    if (!cpf || cpf.length < 11) {
      setValidationResult(null);
      return;
    }

    // Verificar se tem pelo menos 11 dígitos (ignorando formatação)
    const cpfDigits = cpf.replace(/\D/g, '');
    if (cpfDigits.length < 11) {
      setValidationResult(null);
      return;
    }

    setIsValidating(true);
    const handler = setTimeout(async () => {
      try {
        const result = await LicenseService.validateCPF(cpf);
        setValidationResult(result);
      } catch (error) {
        setValidationResult({
          success: false,
          message: 'Erro ao validar CPF.',
          valid: false,
          available: false,
        });
      } finally {
        setIsValidating(false);
      }
    }, 500); // Debounce de 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [cpf]);

  return { cpf, setCPF, isValidating, validationResult };
};

export default useCPFValidation;
